// mypreset.ts

import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

// Define your custom primary color shades based on rgb(62, 117, 179) which is #3E75B3
const customBlueColorPalette = {
    // IMPORTANT: These are *example* shades. For a truly harmonious and professional theme,
    // I highly recommend using a color palette generator (e.g., material.io color tool, coolors.co)
    // where you can input #3E75B3 and generate a full range of shades (50-950).
    // Adjust these hex values to get the exact visual consistency you desire for each shade.
    50: '#eef4fa',    // Very light blue
    100: '#d7e4f3',   // Lighter blue
    200: '#abccef',
    300: '#7ea4e1',
    400: '#5383d6',
    500: '#3E75B3',   // Your desired base color: rgb(62, 117, 179)

    // Adjusted "medium dark" shades (these are examples, fine-tune them!)
    600: '#3E75B3',   // A step darker than 500
    700: '#3E75B3',   // Another step darker
    800: '#3E75B3',   // Darker still, but not "very dark" like black
    900: '#3E75B3',   // A dark blue, but not pure black
    950: '#3E75B3'    // Still a dark blue, adjust this to your "medium dark" preference
                      // You can make this less dark, e.g., '#0a1a2a' or '#0d2d4d'
                      // if you want it closer to the 900 or 800 shade.
};

const customBluePreset = definePreset(Aura, {
    semantic: {
        primary: {
            // ALL THESE SHADES MUST BE DEFINED for consistent theming
            50: customBlueColorPalette[50],
            100: customBlueColorPalette[100],
            200: customBlueColorPalette[200],
            300: customBlueColorPalette[300],
            400: customBlueColorPalette[400],
            500: customBlueColorPalette[500],
            600: customBlueColorPalette[600],
            700: customBlueColorPalette[700],
            800: customBlueColorPalette[800],
            900: customBlueColorPalette[900],
            950: customBlueColorPalette[950] // This will now be your defined "medium dark" value
        },
        // Adjust light/dark color schemes to reference your new custom shades for consistency
        colorScheme: {
            light: {
                primary: {
                    color: customBlueColorPalette[800], // Example: use a darker blue for text on light backgrounds
                    inverseColor: '#ffffff',
                    hoverColor: customBlueColorPalette[600],
                    activeColor: customBlueColorPalette[700]
                },
                highlight: {
                    background: customBlueColorPalette[500], // Use your base blue for highlight background
                    focusBackground: customBlueColorPalette[700],
                    color: '#ffffff',
                    focusColor: '#ffffff'
                }
            },
            dark: {
                primary: {
                    color: customBlueColorPalette[100], // Example: use a lighter blue for text on dark backgrounds
                    inverseColor: customBlueColorPalette[950],
                    hoverColor: customBlueColorPalette[200],
                    activeColor: customBlueColorPalette[300]
                },
                highlight: {
                    background: 'rgba(250, 250, 250, .16)', // Generic alpha values are fine, or tie to your palette
                    focusBackground: 'rgba(250, 250, 250, .24)',
                    color: 'rgba(255,255,255,.87)',
                    focusColor: 'rgba(255,255,255,.87)'
                }
            }
        }
    }
});

export default customBluePreset;